import api from "../index";
import { apiUrl } from "../../utils/constants";

export const GetSalonTeams = (id, params) =>
  api.get(`${apiUrl.salon_teams}/${id}`, { params });
